import styled from "styled-components";

export const DatePickerContainer = styled.div<any>`
  && .k-daterangepicker-wrap{
    width: 100%;
  }
  && .k-textbox-container{
    width: 49%;
  }
`;